
export default function Hero() {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('produtos');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/4cfc6ee9de00fe5f55c09627c72ab2bb.jpeg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Retângulo com logo e frase */}
          <div className="bg-white/60 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-2xl mb-8 md:mb-12">
            {/* Logo - Área editável */}
            <div className="mb-4" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/10868b9667f14dc58518266006d3cd12.png"
                alt="AGUBEL Logo"
                className="w-80 md:w-96 h-auto mx-auto object-contain"
              />
            </div>
            
            {/* Frase dentro do retângulo */}
            <p className="text-gray-800 text-lg md:text-2xl font-semibold leading-relaxed mb-4">
              Inovação e qualidade em queijos de cabra artesanais
            </p>

            {/* Texto adicional dentro do retângulo */}
            <p className="text-gray-600 text-sm md:text-lg leading-relaxed">
              Produtos lácteos de cabra com excelência, sustentabilidade e valorização da agricultura familiar desde 2004
            </p>
          </div>

          <button
            onClick={scrollToProducts}
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 md:py-4 md:px-10 rounded-full text-base md:text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Conheça Nossos Produtos
          </button>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl md:text-4xl"></i>
      </div>
    </section>
  );
}
